import Vue from "vue";
import titleMixin from "@/mixins/title";
export default Vue.extend({
    mixins: [titleMixin],
    data() {
        return {
            title: this.$t("serviceMarketingCategories.create.title"),
            data: {
                name: "",
                description: undefined,
                order: 0
            },
            validationOptions: {
                rules: {
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    description: {
                        maxLength: 255,
                    }
                }
            }
        };
    },
    methods: {
        create() {
            return this.$store.dispatch("serviceMarketingCategory/create", {
                serviceMarketingCategory: this.data
            });
        },
        createSuccess() {
            this.$toast.showSuccessToast(this.$t("serviceMarketingCategories.create.toastSuccessTitle"), this.$t("serviceMarketingCategories.create.toastSuccessContent", {
                name: this.data.name
            }));
            return this.$router.push("/administration/service-marketing-categories");
        },
        cancel() {
            return this.$router.push("/administration/service-marketing-categories");
        }
    }
});
